<template>

        <panel-navigation>
            <h1 class="text-lg font-semibold mb-3">Email Signatures</h1>

            <hr class="border-b border-gray-100 mb-3">

              <div class="flex flex-row flex-wrap">
                <div v-for="(item, index) in images" :key="'image-' + index" class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>Signature {{ index + 1 }}</strong>
                      <div class="text-gray-600 text-sm" style="padding: 10px; height: 160px; border: solid 1px #CCCCCC; border-radius: 5px; width: 100%; margin-top: 10px; text-align: center; vertical-align: middle; margin-bottom: 15px; line-height: 150px;">
                        <div :id="'emsgn-' + index"><a v-if="reviewFunnelUrl" :href="reviewFunnelUrl"><img :src="item" style="display: inline;" /></a></div>
                      </div>

                      <div class="bg-green-500 hover:bg-green-400 text-white inline-block rounded py-2 px-3 cursor-pointer" @click="copyWithStyle('emsgn-' + index)"><i class="mdi mdi-content-copy"></i> Copy</div>
                    </div>
                  </v-card>
                </div>
              </div>
            </panel-navigation>
</template>

<script>
import axios from 'axios'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  components: {
    PanelNavigation
  },



    data: function() {
        return {
            reviewFunnelUrl: "",
            images: [
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n1.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n2.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n3.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n4.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n5.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n6.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n7.png',
                'https://lsaapi-uploads.s3.us-east-1.amazonaws.com/rvemsgn/n8.png'
            ]
        }
    },

    methods: {

      copyWithStyle(element) {

        const doc = document;
        const text = doc.getElementById( element );
        let range;
        let selection;

        if( doc.body.createTextRange ) {

            range = doc.body.createTextRange();
            range.moveToElement( text );
            range.select();

        } else if ( window.getSelection ) {

            selection = window.getSelection();

            range = doc.createRange();
            range.selectNodeContents( text );

            selection.removeAllRanges();
            selection.addRange( range );

        }

        document.execCommand( 'copy' );
        window.getSelection().removeAllRanges();
        // document.getElementById( 'clickMe' ).value = 'Copied to clipboard!';

        this.$swal({
                title: "Copied",
                    text: "Email Signature code copied successfully!",
                    showCancelButton: false,
                });
      },

        getReviewFunnel: async function() {
            console.log('this.force_business', this.force_business)
            let self = this;

            let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/review-funnels/get-settings', {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                },
            })
            
            this.reviewFunnelUrl = window.location.origin + '/' + response.data.review_funnel.short_name;
        },
        
        getFunnelUrl() {
            return this.reviewFunnelUrl;
        },

        getCopyCode(item, index) {
            return '<a href="' + this.getFunnelUrl() + '"><img src="' + item + '" /></a>';
        },

        onCopy: function (e) {
            this.$swal({
                title: "Copied",
                    text: "Email Signature code copied successfully!",
                    showCancelButton: false,
                });
        },
        onError: function (e) {
            alert('Failed to copy the text to the clipboard')
            // console.log(e);
        },
    },

    created() {
        this.getReviewFunnel();
    }
}
</script>